// Cambiar las líneas tras cotizar descarta el crédito PENDING (REQ-109). Puro.
import type { WizardSession } from './types';

/** Aviso tras un cambio que descartó la cotización (líneas, promo, regalo o código). */
export const QUOTE_DISCARDED_MESSAGE =
    'La cotización se descartó porque cambió la venta. Al continuar, vuelve a cotizar.';

/** Aviso antes de un cambio que descarta la cotización viva. */
export const QUOTE_DISCARD_WARNING =
    'Si cambias la venta, la cotización se descarta y tienes que volver a cotizar.';

/** El cambio dejó sin crédito a una sesión que ya lo tenía. */
export function quoteDiscarded(before: WizardSession | undefined, after: WizardSession): boolean {
    return !!before?.loan?.creditId && !after.loan?.creditId;
}
